<template v-model="tipsVisible" v-if="tipsVisible">
  <div class="mask maskon" v-if="tipsVisible">
    <div class="tsk tsk_tc">
      <div class="hd">
        <h2 class="t_cap">{{ title }}</h2>
      </div>
      <div class="bd">
        <div class="d t_info">
          <p v-if="type == 1">{{ content }}</p>
          <template v-if="type == 3">
            <p>{{ content }}</p>
            <input
              type="text"
              class="inp_ts"
              v-model="pwd"
              placeholder="请输入原因"
            />
          </template>

          <input
            v-if="type == 2"
            type="text"
            class="inp_ts"
            v-model="pwd"
            placeholder="请输入新密码"
          />
        </div>
        <div class="d t_btn">
          <p class="btn4 btn4_qx" @click="close" v-if="cbtn">取消</p>
          <p class="btn4 btn4_qd" @click="confirm">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
export default {
  setup() {
    const tipsVisible = ref(false);
    const pwd = ref("");
    const content = ref("");
    const type = ref(1);
    const title = ref("提示");
    const cbtn = ref(false);
    const close = () => {
      tipsVisible.value = false;
    };
    const confirm = () => {
      close();
    };
    return {
      pwd,
      tipsVisible,
      title,
      close,
      confirm,
      content,
      type,
      cbtn,
    };
  },
};
</script>
<style lang="less" scoped>
.tsk_tc .hd {
  display: block;
}
.tsk .hd {
    height: 3.37rem;
    text-align: center;
    display: flex;
    justify-content: center;
}
</style>
